// Defense in depth for PDF.js. The vulnerability is patched in v4.8.69, but
// this also prevents dynamic evaluation if a future integration changes it.
export const SAFE_PDF_DOCUMENT_OPTIONS = Object.freeze({
  isEvalSupported: false,
});
